module.exports = __webpack_public_path__ + "russierenouvelables/img/2-types-articles.67afaaf0.webp";